import { FetchActivitiesByQueryCommand } from '@/Application/Activities'
import { ActivityRepository, ActivityQuery } from '@/Domain/Activities'
import { LanguageCode } from '@/Domain/Localization'
import { ActivityDto } from './ActivityDto'

export class FetchActivitiesByQueryCommandHandler {
  private _repository: ActivityRepository

  constructor (repository: ActivityRepository) {
    this._repository = repository
  }

  async handle (command: FetchActivitiesByQueryCommand): Promise<ActivityDto[]> {
    try {
      const query = new ActivityQuery(command.query())
      const languageCode = command.languageCode() as LanguageCode
      const response = await this._repository.byQuery(languageCode, query)
      return response.map(current => ActivityDto.fromActivity(current))
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
